import { render } from "./ClientListView.vue?vue&type=template&id=1ac67aea"
import script from "./ClientListView.vue?vue&type=script&lang=js"
export * from "./ClientListView.vue?vue&type=script&lang=js"

import "./ClientListView.vue?vue&type=style&index=0&id=1ac67aea&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__